import { z } from "zod";

export const RetainageSchema = z.object({
  lineRefNumber: z.string(),
  description: z.string(),
  retainageId: z.number(),
  drawItemId: z.string(),
  projectEntityId: z.string(),
  thisDrawLoan: z.number(),
  thisDrawEquity: z.number(),
  retainagePriorDraw: z.number(),
  retainageThisDraw: z.number(),
  totalRetainagePriorDraw: z.number(),
  totalRetainage: z.number(),
  releasedPriorDraw: z.number(),
  releasedThisDraw: z.number(),
  totalReleasedPriorDraw: z.number(),
  totalReleased: z.number(),
  retainageBalance: z.number(),
});

export const EntityRetainageSchema = z.object({
  projectEntityId: z.string(),
  projectEntityDisplay: z.string(),
  retainageList: z.array(RetainageSchema),
  deletedRetainageList: z.array(RetainageSchema),
});

export const DrawBasedRetainageSchema = z.object({
  retainagePriorDraws: z.number().default(0),
  retainageThisDraw: z.number().default(0),
  releasedPriorDraws: z.number().default(0),
  releasedThisDraw: z.number().default(0),
});

export type Retainage = z.infer<typeof RetainageSchema>;
export type EntityRetainage = z.infer<typeof EntityRetainageSchema>;
export type DrawBasedRetainage = z.infer<typeof DrawBasedRetainageSchema>;
